import { configureStore } from "@reduxjs/toolkit";
import { reducer } from "./root-reducer";
import { api } from "./api";

export const store = configureStore({
  reducer: reducer,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(api.middleware);
  },
});
